import { Box, SxProps, Theme } from "@mui/material";
import React from "react";

interface BlockWrapperProps {
  children: React.ReactNode;
  sx?: SxProps<Theme>;
}

const BlockWrapper: React.FC<BlockWrapperProps> = ({ children, sx }) => {
  return (
    <Box
      sx={{
        px: { xs: "20px", sm: "30px", md: "40px", lg: "40px" },
        paddingBlock: "100px",
        ...sx,
      }}
    >
      {children}
    </Box>
  );
};

export default BlockWrapper;
